import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';
import {SEARCH_GLYPH} from '../../const/Glyphicons';
import textTranslates from './translate.json';

const ShowRodoClause = ({onShowRodoClauseClick}) => {
    return(
        <Button
            id="showRodoClause"
            glyph={SEARCH_GLYPH}
            title={textTranslates.showRodoClause}
            onClick={onShowRodoClauseClick}
            label={textTranslates.showRodoClause} />
    );
};

ShowRodoClause.propTypes = {
    onShowRodoClauseClick: PropTypes.func,
};

export default ShowRodoClause;


// WEBPACK FOOTER //
// ./src/components/RodoClause/ShowRodoClause.js